export const TEAMS_NOT_PERMITTED_ERROR = 'TEAMS_NOT_PERMITTED_ERROR' as const;

const LOAN_NOT_FOUND_ERROR_MESSAGES = ['Cannot find loan', 'Attempted to get loan for wrong company'] as const;

export const isLoanNotFoundError = (message: string): boolean =>
  LOAN_NOT_FOUND_ERROR_MESSAGES.some((m) => message.includes(m));
